<template>
    <div class="privacy-rdr">
        <privacy-paragraphs />
    </div>
</template>

<script>
import PrivacyParagraphs from './PrivacyParagraphs'
import {mapGetters, mapState} from 'vuex'

export default {
  components: {PrivacyParagraphs},
  data () {
    return {
      fldName: null,
      formData: {},
      formPublicData: {},
      otherFormsData: [],
      submitBtnDisabled: false,
      btnClasses: '',
      isButton: false,
      buttonType: 'submit',
      greaterThan600: window.innerWidth > 600
    }
  },
  computed: {
    ...mapState(['submitCaption', 'submitClass', 'id']),
    ...mapGetters(['allScrolled', 'privacyIsValid', 'allFlags'])
  }
}
</script>

<style lang="scss">
    .mm-prv-agree-submit-container {
        text-align: left;
        margin-top:10px;

    }
</style>



// WEBPACK FOOTER //
// src/components/Privacy.vue